module.exports = __webpack_public_path__ + "img/1.98e3cba3.webp";